import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/ui/misc";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t("states.notFound")}
      description={t("states.notFoundHint")}
      action={
        <Link to="/" className="text-primary hover:underline">
          {t("states.backHome")}
        </Link>
      }
    />
  );
}
